import { Box, Tab, Tabs } from "@mui/material";
import * as React from "react";
import { useSearchParams } from "react-router-dom";
import { ConvertSVG } from "../ConvertSVG";
import { UberAdmin } from "../Settings/UberAdmin";
import { Activity } from "./Activity";
import { AircraftAdmin } from "./AircraftAdmin";
import { AnnouncementsAdmin } from "./AnnouncementsAdmin";
import { AuthorizedAccounts } from "./AuthorizedAccounts";
import { EnterTheDojo } from "./EnterTheDojo";
import { FAAMapping } from "./FAAMapping";
import { FBOAdmin } from "./FBOAdmin";
import { MovableObstacleAdmin } from "./MovableObstacleAdmin";
import { SuperUserAdmin } from "./SuperUserAdmin";
import { TowingEquipmentAdminScreen } from "./TowingEquipmentAdmin";

type Props = {};

export const SuperAdmin: React.FC<Props> = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Get initial tab from URL, default to "authorized-accounts"
  const [activeTab, setActiveTab] = React.useState<string>(
    searchParams.get("tab") || "authorized-accounts"
  );

  // Update URL when tab changes
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
    setSearchParams({ tab: newValue }, { replace: true });
  };

  return (
    <Box sx={{ p: 2 }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab value="authorized-accounts" label="Authorized Accounts" />
        <Tab value="fbos" label="FBOs" />
        <Tab value="users" label="Users" />
        <Tab value="faa-mapping" label="FAA Mapping" />
        <Tab value="announcements" label="Announcements" />
        <Tab value="activity" label="Activity" />
        <Tab value="movable-obstacles" label="Movable Obstacles" />
        <Tab value="towing-equipment" label="Towing Equipment" />
        <Tab value="aircraft" label="Aircraft" />
        <Tab value="labeling" label="Labeling" />
        <Tab value="convert-svgs" label="Convert SVGs" />
        <Tab value="system-status" label="System Status" />
      </Tabs>
      {activeTab === "authorized-accounts" && <AuthorizedAccounts />}
      {activeTab === "fbos" && <FBOAdmin />}
      {activeTab === "users" && <SuperUserAdmin />}
      {activeTab === "faa-mapping" && <FAAMapping />}
      {activeTab === "announcements" && <AnnouncementsAdmin />}
      {activeTab === "activity" && <Activity />}
      {activeTab === "movable-obstacles" && <MovableObstacleAdmin />}
      {activeTab === "towing-equipment" && <TowingEquipmentAdminScreen />}
      {activeTab === "aircraft" && <AircraftAdmin />}
      {activeTab === "labeling" && <EnterTheDojo />}
      {activeTab === "convert-svgs" && <ConvertSVG />}
      {activeTab === "system-status" && <UberAdmin />}
    </Box>
  );
};
